'use client'

import { ReactNode } from 'react'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from '@/components/ui/collapsible'
import { ChevronDown } from 'lucide-react'

export interface IntegrationCardLayoutProps {
  title: string
  description?: string
  icon?: ReactNode
  headerAction?: ReactNode
  children: ReactNode
  /** Whether to start expanded. Defaults to false (collapsed). */
  defaultOpen?: boolean
}

export function IntegrationCardLayout({
  title,
  description,
  icon,
  headerAction,
  children,
  defaultOpen = false,
}: IntegrationCardLayoutProps) {
  return (
    <Collapsible defaultOpen={defaultOpen}>
      <Card>
        <CollapsibleTrigger asChild>
          <CardHeader className="cursor-pointer hover:bg-muted/50 transition-colors">
            <div className="flex items-center justify-between w-full">
              <div className="flex items-start gap-3">
                {icon && <span className="mt-0.5 text-muted-foreground">{icon}</span>}
                <div>
                  <CardTitle className="flex items-center gap-2 text-lg font-semibold">{title}</CardTitle>
                  {description ? <CardDescription>{description}</CardDescription> : null}
                </div>
              </div>
              <div className="flex items-center gap-3">
                {headerAction ? <div onClick={(e) => e.stopPropagation()}>{headerAction}</div> : null}
                <ChevronDown className="w-5 h-5 text-muted-foreground transition-transform duration-200 [[data-state=open]_&]:rotate-180" />
              </div>
            </div>
          </CardHeader>
        </CollapsibleTrigger>
        <CollapsibleContent>
          <CardContent className="pt-0">{children}</CardContent>
        </CollapsibleContent>
      </Card>
    </Collapsible>
  )
}
